import { formatDistanceToNow } from 'date-fns';
import { useDateFnLocale, useSPIntl } from 'hooks/useIntl';
import { FC } from 'react';

type PricingDateProps = Readonly<{
  when: Date;
}>;

export const PricingDate: FC<PricingDateProps> = ({ when }) => {
  const locale = useDateFnLocale();
  const { formatMessage } = useSPIntl();
  const formattedDate = formatDistanceToNow(when, { locale });

  if (!when) {
    return null;
  }
  return (
    <span className="font-italic fs-6">
      {formatMessage({ id: 'dashboard.lastUpdated.label' }, { age: formattedDate })}
    </span>
  );
};
